import { Dialog, styled } from "@mui/material";

export const CustomStyledSuccessDailog = styled(Dialog) <any>`
  -webkit-backdrop-filter: blur(17px);
  backdrop-filter: blur(17px);
  background-color: rgba(0, 0, 0, 0.7);

  .success-message {
    color: var(--white-color);
    text-align: center;
    width: 350px;
    font-size: 1.6rem;
  }

  & .MuiDialog-paper {
    border-radius: 4rem;
    width: 45rem;
    min-height: 20rem;
    display: flex;
    justify-content: center;
    text-align: center;
    background-color: var(--tertiary-theme-color);
    padding: 2rem;
    box-sizing: border-box;
  }

  @media screen and (max-width: 640px) {
    .success-message {
      width: 100%;
      font-size: 1.4rem;
    }
    & .MuiDialog-paper {
      width: 100%;
      min-height: 20%;
      height: auto;
      margin: 20px;
      padding: 2rem;
    }
  }
  @media (min-width: 640px) and (max-width: 1024px) {
    .success-message {
      width: 100%;
      font-size: 1.4rem;
    }
    & .MuiDialog-paper {
      width: 40rem;
      min-height: 20%;
      height: auto;
    }
  }
`;
